import {
  INVENTORY_SUPPLIER_PAGE_REQUEST,
  INVENTORY_SUPPLIER_SUPPLIERS_REQUEST,
  INVENTORY_SUPPLIER_SET_OUTLETS,
  INVENTORY_SUPPLIER_ON_CHANGE_KEYWORD,
  INVENTORY_SUPPLIER_SET_SUPPLIERS,
  INVENTORY_SUPPLIER_EXPORT_SUPPLIER,
  INVENTORY_SUPPLIER_SET_PROFILE,
  INVENTORY_SUPPLIER_OPEN_RIGHT_COLUMN,
  INVENTORY_SUPPLIER_CLOSE_RIGHT_COLUMN,
  INVENTORY_SUPPLIER_ASK_DELETE_SUPPLIER,
  INVENTORY_SUPPLIER_ON_CLICK_ROW,
  INVENTORY_SUPPLIER_SUBMIT_FORM_CREATE,
  INVENTORY_SUPPLIER_SUBMIT_FORM_UPDATE,
  INVENTORY_SUPPLIER_ON_CLICK_CANCEL,
  INVENTORY_SUPPLIER_SET_SUPPLIER_DETAIL,
  INVENTORY_SUPPLIER_DELETE_SUPPLIER,
  INVENTORY_SUPPLIER_OPEN_DELETE_SUPPLIER_MODAL,
  INVENTORY_SUPPLIER_CLOSE_DELETE_SUPPLIER_MODAL,
  INVENTORY_SUPPLIER_CANCEL_DELETE_SUPPLIER,
  INVENTORY_SUPPLIER_ON_CLICK_CREATE_SUPPLIER,
  INVENTORY_SUPPLIER_IS_SUBMITTING_FORM
} from './constants'

export function pageRequest () {
  return {type: INVENTORY_SUPPLIER_PAGE_REQUEST, payload: {}}
}

export function suppliersRequest (params) {
  return {type: INVENTORY_SUPPLIER_SUPPLIERS_REQUEST, payload: {params}}
}

export function setOutlets (outlets) {
  return {type: INVENTORY_SUPPLIER_SET_OUTLETS, payload: {outlets}}
}

export function onChangeKeyword (keyword) {
  return {type: INVENTORY_SUPPLIER_ON_CHANGE_KEYWORD, payload: {keyword}}
}

export function setSuppliers (suppliers) {
  return {type: INVENTORY_SUPPLIER_SET_SUPPLIERS, payload: {suppliers}}
}

export function openRightColumn () {
  return {type: INVENTORY_SUPPLIER_OPEN_RIGHT_COLUMN, payload: {}}
}

export function closeRightColumn () {
  return {type: INVENTORY_SUPPLIER_CLOSE_RIGHT_COLUMN, payload: {}}
}

export function askDeleteSupplier (supplier) {
  return {type: INVENTORY_SUPPLIER_ASK_DELETE_SUPPLIER, payload: {supplier}}
}

export function submitFormCreate (data, previousSuppliers) {
  return {type: INVENTORY_SUPPLIER_SUBMIT_FORM_CREATE, payload: {data, previousSuppliers}}
}

export function submitFormUpdate (supplierId, data, previousSuppliers) {
  return {type: INVENTORY_SUPPLIER_SUBMIT_FORM_UPDATE, payload: {supplierId, data, previousSuppliers}}
}

export function onClickRow (supplier) {
  return {type: INVENTORY_SUPPLIER_ON_CLICK_ROW, payload: {supplier}}
}

export function setSupplierDetail (supplier) {
  return {type: INVENTORY_SUPPLIER_SET_SUPPLIER_DETAIL, payload: {supplier}}
}

export function exportSupplier (params, filename) {
  return {type: INVENTORY_SUPPLIER_EXPORT_SUPPLIER, payload: {params, filename}}
}

export function setProfile (profile) {
  return {type: INVENTORY_SUPPLIER_SET_PROFILE, payload: {profile}}
}

export function onClickCancel () {
  return {type: INVENTORY_SUPPLIER_ON_CLICK_CANCEL, payload: {}}
}

export function deleteSupplier (supplier, suppliers) {
  return {type: INVENTORY_SUPPLIER_DELETE_SUPPLIER, payload: {supplier, suppliers}}
}

export function cancelDeleteSupplier () {
  return {type: INVENTORY_SUPPLIER_CANCEL_DELETE_SUPPLIER, payload: {}}
}

export function openDeleteSupplierModal () {
  return {type: INVENTORY_SUPPLIER_OPEN_DELETE_SUPPLIER_MODAL, payload: {}}
}

export function closeDeleteSupplierModal () {
  return {type: INVENTORY_SUPPLIER_CLOSE_DELETE_SUPPLIER_MODAL, payload: {}}
}

export function onClickCreateSupplier () {
  return {type: INVENTORY_SUPPLIER_ON_CLICK_CREATE_SUPPLIER, payload: {}}
}

export function isSubmittingForm (isSubmittingForm) {
  return {type: INVENTORY_SUPPLIER_IS_SUBMITTING_FORM, payload: {isSubmittingForm}}
}



// WEBPACK FOOTER //
// ./app/actions/inventory/supplier/supplier.js